import { dataReady } from '@syncfusion/ej2-schedule';
import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef, ElementRef, ViewContainerRef } from '@angular/core';
import { ReportsService } from './reports.service';
import { groupList, PayorList, importBO, inactiveReport, returnReportBO, spendownListBO, RenvenueInfoLisBO, TotalClaimChargesVsPaidBO, printspendownBO, SpendDownBO, Invoice837P } from './reports.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { SaveBatchFileNewReturnBO } from './reports.model';
// import { Invoice837P } from '../batch/batch.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpErrorResponse } from '@angular/common/http';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { AnyPtrRecord } from 'dns';
import { SearchSettingsModel, ToolbarItems, FilterSettingsModel, IFilter, GridComponent, PageSettingsModel, DataStateChangeEventArgs, QueryCellInfoEventArgs, SelectionSettingsModel, GridModel, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { reportdata } from './reportdata.service';
import { Observable, Subject } from 'rxjs';
import { exportPDF, Group } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-drawing/dist/npm/pdf';
// import { ColumnChangeBO, columnWidth } from '../icd10/icd10.model';

import * as pbi from 'powerbi-client';
import { rejects } from 'assert';
import { DatePipe } from '@angular/common';
// import { environment } from 'src/environments/environment';
import { ConfigurationService } from 'src/app/configuration.service';
import { takeUntil } from 'rxjs/operators';
import { CurrencyPipe } from '@angular/common';
import { PercentPipe } from '@angular/common';
import { TimesheetService } from '../timesheet/timesheet.service';
import { ClientAuthService } from '../client-parent/client-authorization/client-authorization.service';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('reportContainer', { static: false }) reportContainer: ElementRef;
  reportcontain: boolean = true;
  title = 'TestReport';
  report: pbi.Embed;
  public screenHeight: number;
  selecctedTab: string = "Utilization";
  @ViewChild('grid') public grid: GridComponent;
  groupList: groupList[];
  payorList: PayorList[];
  initialPage: object;
  importBO: importBO = new importBO;
  groupId: string = "";
  payorId: string = "";
  startdate: string = "";
  enddate: string = "";
  exstartdate: string = "";
  exenddate: string = "";
  company: string = "";
  clearinghouse: string = "";
  client: string = "";
  employee: string = "";
  type: string = "";
  public data: Observable<DataStateChangeEventArgs>;
  typeList: groupList[];
  fileToUpload: any = "";
  selectedFile: any;
  onDOCFileChangedErr: any = ""
  filepath: string;
  dropdown835: any = [];
  SpenddownList: spendownListBO[]
  Spenddown: spendownListBO[];
  selectedPayor: string;
  PaidAmount: string;
  NetChargeAmount: string;
  Percentage: string;
  locationClaimvsPaidDetails: any;
  AddPercentage: string;
  selectedClaimPayor: string = '00000000-0000-0000-0000-000000000000';
  DateFilterList: any = [];
  DateFilter: any;
  DateFilterclaim: any;

  AgingFilter: any;
  AgingFilterchange: any;
  ChargeFilterList: any = []
  ChargeFilter: string = '00000000-0000-0000-0000-000000000000';
  revenueStart: any = "";
  revenueEnd: any = "";
  ClaimStart: any = "";
  ClaimEnd: any = "";
  FinancialEnd: any = "";
  FinancialStart: any = ""
  AgingStart: any = "";
  AgingEnd: any = "";
  revenuePayorList: any = [];
  ClaimPayorList: any = [];
  RevenueList: RenvenueInfoLisBO[] = [];
  ClaimvspaidList: TotalClaimChargesVsPaidBO = new TotalClaimChargesVsPaidBO
  filterDatevalue = "";
  filterChargevalue = "";
  FinancialList: any;
  AgingList: any;
  selectAll: boolean = false;
  spendDownselectAll: any = [];
  spendwonselectData: any = []
  spendownfilter: any = "All"
  sendspendDown: printspendownBO = new printspendownBO

  claimdatefilter: any = []
  AgingDatefilter: any = []
  AgingDaysfilter: any = []
  claimfilter: any = ""
  select835file: any;
  isDetailed = true;
  isSummary = false;
  isDaily = false;
  isWeekly = false;
  ///////////////////////////////////////////FormatOptions/////////////////////////////////////
  public formatOptions: object;
  ClientId: string;



  //////////===============Create batch initializations===========================//////
  CreatedBatchList: SaveBatchFileNewReturnBO = new SaveBatchFileNewReturnBO();
  invoicelist: Invoice837P = new Invoice837P();
  // batchList: batchList = new batchList();
  ///////////////////////////////Date Piker intialization////////////////////////////////////////////////////////////////
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };


  public myDatePickerOptions1: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };

  public myDatePickerOptions2: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true
  };
  public Keystatusoption: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };


  // batchData: SaveBatchFileNewReturnBO[]=[];
  batchData: any = [];
  @ViewChild('pdflist') pdflist;
  @ViewChild('pdfinactive') pdflistinactive;
  @ViewChild('pdfspendown') pdfspendown;
  @ViewChild('pdfrevenue') pdfrevenue;
  @ViewChild('pdfClaimvsPaid') pdfClaimvsPaid;
  @ViewChild('Financepdf') Financepdf;
  @ViewChild('pdflistsample') pdflistsample;
  @ViewChild('pdfagingSample') pdfagingSample;
  @ViewChild('pdflistexcep') pdflistexcep;
  //////////======================Datepicker fun initialization=================//////////////////////
  date: Date = new Date();
  // invoicelist: Invoice837P = new Invoice837P();
  saveErr: string = "";
  EmployeeDropDown: any;
  ClinetDropDown: any;
  Report835: any;
  viewFiles: boolean = false;
  serviceLineDetail: any;
  Reportfilter: [{ Key: string, value: string }]
  Report: inactiveReport = new inactiveReport()
  InactiveClientReport: returnReportBO[] = []
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public filterSettings: object;
  today: string;
  // ColumnArray: columnWidth[]
  // columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string;
  arraycol: any = [];
  configuration: any;
  disableDP: boolean = true;
  public selectionOptions: SelectionSettingsModel;
  SpendownDataList: any = [];
  childGrid: GridModel;
  ParentSpendownId: any = [];
  locBreak: string = "No";
  spendDownDetails: SpendDownBO = new SpendDownBO()
  reptitle: any = "";
  childSpendownId: any = [];

  constructor(public datepipe: DatePipe, public payerlist: ClientAuthService, public dateservice: DateService, public getReport: ReportsService, public toastrService: ToastrService, public global: GlobalComponent, private ngxService: NgxUiLoaderService, private ref: ChangeDetectorRef,
    @Inject(reportdata) public reportdata: reportdata, public configurationservice: ConfigurationService, public timesheetservice: TimesheetService,
    @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef) {
    this.global.checkforlogout();

    this.configuration = this.configurationservice.getConfiguration();
    // ref.detach();
    // setInterval(() => {
    //   this.ref.detectChanges();
    // }, 10);

    this.data = reportdata;
  }
  agencyid_boll = false
  locationLid: any;
ReportType: 'detail' | 'summary' | null = null;
  ngOnInit(): void {
    this.isDetailed = true
    this.isSummary = false
    this.ReportType='detail'   
    this.onDetailSummaryChange(this.ReportType);
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.today = new Date().toISOString();
    this.batchData.invoice837P = this.invoicelist;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {

      this.locationLid = this.global.globalLocationId;

    }
    else {
      this.locationLid = "00000000-0000-0000-0000-000000000000";
    }
    this.Report.start = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.Report.end = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.getGroupList();
    // this.getpayorList();
    // this.getClearinghouseList();
    // this.getCompanyList();
    this.dates();
    this.disableDP = true;
    this.filterSettings = { type: 'Menu' };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[2], pageSizes: this.pageSizes };
    this.datefiltertype = "0-30";
    this.selectionOptions = {
      checkboxOnly: true
    };
    this.getAllClientDropDown();
    this.Report.filter = '';

    // this.getClient();
    // this.getEmployeeDropDown();
    this.getfilter()
  }

onDetailSummaryChange(value: 'detail' | 'summary') {
  this.ReportType = value;

  if (value === 'detail') {
    // Auto-select Daily
    this.isDaily = true;
    this.isWeekly = false;
  }

  if (value === 'summary') {
    // Hide & reset daily/weekly
    this.isDaily = false;
    this.isWeekly = false;
  }
}

onDailyChange() {
  if (this.isDaily) {
    this.isWeekly = false;
    this.ReportType = 'detail';
  }
}

onWeeklyChange() {
  if (this.isWeekly) {
    this.isDaily = false;
    this.ReportType = 'detail';
  }
}
  Refresh() {
    this.selectAll = false;
    this.spendwonselectData = []
    // this.getspendowndata();
  }
  print = (event): void => {
  };
  spendownselect(args) {
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      this.selectAll = true;
      this.spendwonselectData = [];
      this.spendwonselectData = this.spendDownselectAll;
    }
    else if (args.target.classList.contains('e-checkselect')) {
      this.selectAll = false;
      let result = this.grid.getRowInfo(args.target)
      let data: any = [];
      data = result.rowData
      if (args.checked) {
        if (this.spendwonselectData.length > 0) {
          let val = this.spendwonselectData.filter(s => s == data.id);
          if (val.length == 0) {
            this.spendwonselectData.push(data.id)
          }
        }
        else {
          this.spendwonselectData.push(data.id)
        }
      }
      else {
        const index: number = this.spendwonselectData.indexOf(data.id);
        if (index !== -1) {
          this.spendwonselectData.splice(index, 1);
        }
      }
    }
    else {
      this.spendwonselectData = [];
    }
  }
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();

    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.importBO.orderColumn = state.sorted[0].name;
        this.importBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
        // this.getspendowndata();
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.importBO.field = state.action.currentFilterObject.field;
      this.importBO.matchCase = state.action.currentFilterObject.matchCase;
      this.importBO.operator = state.action.currentFilterObject.operator;
      this.importBO.value = state.action.currentFilterObject.value;
      if (this.importBO.type == "number") {


        this.importBO.value = state.action.currentFilterObject.value.toString();
        this.importBO.field = state.action.currentFilterObject.field;

        if (this.importBO.field == "amount") {
          this.importBO.value = state.action.currentFilterObject.value.toString();
          this.importBO.type = "decimal";
        }


      }
      if (this.importBO.type == "date") {

        this.importBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.importBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.importBO.value = state.action.currentFilterObject.value;
        this.importBO.field = state.action.currentFilterObject.field;
        if (this.importBO.field == "invoiceDate") {
          this.importBO.type = "date";
          this.importBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        }
        if (this.importBO.field == "amount") {
          this.importBO.value = state.action.currentFilterObject.value.toString();
          this.importBO.type = "decimal";
        }
      }

      this.importBO.matchCase = state.action.currentFilterObject.matchCase;
      this.importBO.operator = state.action.currentFilterObject.operator;
      // this.getspendowndata();
    }

    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.importBO.field = "client";
        this.importBO.matchCase = false;
        this.importBO.operator = "startswith";
        this.importBO.value = "";
        this.importBO.type = "string";
        // this.getspendowndata();
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      // if (this.grid.pagerModule.pagerObj.pageSize != this.arraycol[0].Client.Pagesize) {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].SpenddownReport.Pagesize != state.take) {
          this.arraycol[0].SpenddownReport.Pagesize = state.take
          // this.SaveColumnwidth();
          // }
        }
      }
    }
    // this.getspendowndata();
  }
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }
  public onActionComplete(args) {
    this.importBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.importBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    // this.getspendowndata()
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.importBO.type = args.columnType
    }

  }
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      const tooltip: Tooltip = new Tooltip({
        content: args.data[args.column.field].toString(),
        position: 'RightCenter',


      }, args.cell as HTMLTableCellElement);
    }
  }
  getspendowndata() {
    if (this.spendownfilter == "True") {
      this.importBO.spendownfilter = true
    }
    else if (this.spendownfilter == "False") {
      this.importBO.spendownfilter = false
    }
    else {
      this.importBO.spendownfilter = null
    }

    // this.reportdata.execute(this.importBO);
    //   let count = 0
    //   this.data.pipe(takeUntil(this.onDestroy$)).subscribe((datas: any) => {
    //     count = count + 1
    //     if (datas != null && datas != undefined && count == 1) {
    //       // this.getColumnwidth();
    //     }
    //     this.spendDownselectAll = datas.idList;
    //     let val: any = [];
    //     if (this.selectAll) {
    //       if (datas.result.length > 0) {
    //         datas.result.forEach((element, index) => {
    //           val.push(index)
    //         });
    //         setTimeout(() => {
    //           this.grid.selectionModule.selectRows(val);
    //         }, 1000);
    //       }


    //     }
    //     else {
    //       if (datas.result.length > 0) {
    //         datas.result.forEach((element, index) => {
    //           if (this.spendwonselectData.length > 0) {


    //             this.spendwonselectData.forEach(element1 => {
    //               if (element.id == element1) {
    //                 val.push(index)
    //               }
    //             });
    //           }
    //         });
    //         if (val.length > 0) {
    //           setTimeout(() => {
    //             this.grid.selectionModule.selectRows(val);
    //           }, 1000);
    //         }
    //       }
    //     }
    //   })
  }
  /////////////////////////////////tab change///////////////////////////////////////////////////////////////
  tabchange(val) {

    this.selecctedTab = val;
    if (val == "Submission Reports") {
      this.company = '';
      this.clearinghouse = '';
      this.startdate = '';
      this.enddate = '';
    }

    if (val == "Exception Reports") {
      this.company = '';
      this.groupId = '';
      this.payorId = '';
      this.company = '';
      this.client = '';
      this.employee = '';
      this.select835file = '';
      // this.getClient();
      // this.getEmployeeDropDown();
      this.getType();
      this.get835dropdown()
    }
    if (val == "InactiveClientReport") {
      this.Report.filter = '';
      this.Report.start = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      this.Report.end = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
      // this.getClient();
      // this.getEmployeeDropDown();
      this.getfilter()
    }
    if (val == "SpenddownReport") {
      this.spendownfilter = 'All';
      this.SpenddownList = [];
      this.selectedFile = null;
      this.selectAll = false;
      this.spendwonselectData = []
      this.getspendowndata()
    }
    if (val == "RevenueReport") {
      this.selectedPayor = '00000000-0000-0000-0000-000000000000';
      this.revenueStart = "";
      this.revenueEnd = "";
      this.getPayer();
      this.getDateLid();
      this.getchargeLid()
    }
    if (val == "ClaimChargevsPaid") {
      this.selectedClaimPayor = '00000000-0000-0000-0000-000000000000';
      this.ClaimStart = "";
      this.ClaimEnd = ""
      this.getPayer();
      this.getclaimcharge()
    }
    if (val == "Financial") {
      this.FinancialStart = "";
      this.FinancialEnd = "";
    }
    if (val == "AgingReport") {
      this.AgingStart = "";
      this.AgingEnd = "";
      this.company = '';
      this.client = '';
      this.getPayer();
      // this.getClient();
      this.getAgingcharge();
      this.getAgingdate();
    }
    if (val == "Utilization") {
      this.startdate = ""
      this.enddate = ""
      this.ClientId = ""
    }

  }

  selectTab(event) {
    if (event.target.innerText == "Submission Report") {
      this.selecctedTab = event.target.innerText

    }
    if (event.target.innerHTML == "Exception Report") {

      this.selecctedTab = event.target.innerHTML
      // this.getClient();
      // this.getEmployeeDropDown();
      this.getType();


    }
    if (event.target.innerHTML == "InactiveClientReport") {

      this.selecctedTab = event.target.innerHTML
      this.getfilter()

    }
  }

  ///////////========================Get Group payor list==================================//////////////////
  getGroupList() {
    let param = new URLSearchParams();
    param.append("Code", "GROUP");
    this.getReport.getgroupList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.groupList = data;
      this.groupList.forEach(element => {
        element.label = element.Value,
          element.value = element.Key.toString();
        // this.ngxService.stop()
      })
    })
  }


  ///////////========================Get Exception TYpe list==================================//////////////////
  getType() {
    let param = new URLSearchParams();
    param.append("Code", "EXCEPTIONTYPE");
    this.getReport.getgroupList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.typeList = data;
      this.typeList.forEach(element => {
        element.label = element.Value,
          element.value = element.Key.toString();
        // this.ngxService.stop()
      })


    })
  }

  ///////////========================Get payor list==================================//////////////////
  getpayorList() {
    let param = new URLSearchParams();
    let GroupId: number = ((this.groupId != '' && this.groupId != null) && this.groupId != undefined) ? +this.groupId : 0

    param.append("GroupId", GroupId.toString());
    this.getReport.getPayorList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.payorList = data;

      this.payorList.forEach(element => {
        element.label = element.Value,
          element.value = element.Key.toString();
      })

    })
  }

  setDefaultgroupval(data) {
    if (data == undefined) {
      this.groupId = "";
      this.payorId = "";
      this.payorList = [];
    }
    else {
      this.getpayorList();
    }
  }
  setDefaultpayorval(data) {
    if (data == undefined) {
      this.payorId = "";
    }
  }
  checkOverallData() {
    // if (this.companyId == "" && this.statusLid == ""
    //   && this.groupId == "" && this.getBatchFilterList.payorId == ""
    //   && this.clientId == "" && this.getBatchFilterList.employeeId == "") {
    //   // this.claimWithoutBatch = [];
    // }
  }



  //////////////////////////Date Piker Date Change///////////////////////////////////////////////////////////////////////
  newdates(event, type, name) {
    if (type == "inputchage") {

      if (name == 'start') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.startdate = val1;
        }
      }
      if (name == 'end') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.enddate = val1;
        }
      }
      if (name == 'exstart') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.exstartdate = val1;
        }
      }
      if (name == 'exend') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.exenddate = val1;
        }
      }
      if (name == 'inactivestart') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.Report.start = val1;
        }
      }
      if (name == 'inactiveend') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.Report.end = val1;
        }
      }
      if (name == 'revenuestart') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.revenueStart = val1;
        }
      }
      if (name == 'revenueend') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.revenueEnd = val1;
        }
      }
      if (name == 'claimStart') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClaimStart = val1;
        }
      }
      if (name == 'claimEnd') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.ClaimEnd = val1;
        }
      }
      if (name == 'financialStart') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FinancialStart = val1;
        }
      }
      if (name == 'financialEnd') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FinancialEnd = val1;
        }
      }
    }
    if (type == "datechagned") {

      if (name == 'start') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.startdate = val1;
        }
        // let dat=new Date(this.startdate);
        // dat.setDate(dat.getDate() + 180);
        // this.myDatePickerOptions1.disableSince= { year: new Date(this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy")).getFullYear(), month: new Date(this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy")).getMonth() + 1, day: new Date(this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy")).getDate() + 1 };
        // this.myDatePickerOptions1.disableUntil= { year: new Date(this.startdate).getFullYear(), month: new Date(this.startdate).getMonth() + 1, day: new Date(this.startdate).getDate() - 1};
        // this.disableDP=false;
        // this.enddate=this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy");
      }
      if (name == 'end') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.enddate = val1;
        }
      }
      if (name == 'exstart') {
        this.disableDP == false ? this.disableDP = true : true;
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.exstartdate = val1;
        }
        let dat = new Date(this.exstartdate);
        dat.setDate(dat.getDate() + 180);
        this.myDatePickerOptions2.disableSince = { year: new Date(this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy")).getFullYear(), month: new Date(this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy")).getMonth() + 1, day: new Date(this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy")).getDate() + 1 };
        this.myDatePickerOptions2.disableUntil = { year: new Date(this.exstartdate).getFullYear(), month: new Date(this.exstartdate).getMonth() + 1, day: new Date(this.exstartdate).getDate() - 1 };
        this.exenddate = this.datepipe.transform(new Date(dat).toISOString().replace("Z", ""), "MM/dd/yyyy");
      }
      if (name == 'exend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.exenddate = val1;
        }
      }
      if (name == 'inactivestart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.Report.start = val1;
        }
      }
      if (name == 'inactiveend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.Report.end = val1;
        }
      }
      if (name == 'revenuestart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.revenueStart = val1;
        }
      }
      if (name == 'revenueend') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.revenueEnd = val1;
        }
      }
      if (name == 'claimStart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClaimStart = val1;
        }
      }
      if (name == 'claimEnd') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.ClaimEnd = val1;
        }
      }
      if (name == 'financialStart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FinancialStart = val1;
        }
      }
      if (name == 'financialEnd') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FinancialEnd = val1;
        }
      }
      if (name == 'agingStart') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.AgingStart = val1;
        }
      }
      if (name == 'agingEnd') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.AgingEnd = val1;
        }
      }
    }
  }



  //////===========================Employee list===========================================///
  getEmployeeDropDown() {
    this.getReport.getEmployee().pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.EmployeeDropDown = data;
      this.EmployeeDropDown.forEach(element => {
        element.Key = element.Key;

      })
    });

  }
  ///////////////////////////////////////get client///////////////////////////////////////////////////////////////////

  getClient() {
    this.getReport.getClient().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClinetDropDown = data;
      this.ClinetDropDown.forEach(element => {
        element.id = element.id.toString();
      })
    });
  }
  //=========================================getcompany list=============================//
  companyList: any = [];
  // getCompanyList() {
  //   this.getReport.getCompany().pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
  //     this.companyList = data;
  //     this.companyList.forEach(element => {
  //       element.label = element.Value;
  //       element.value = element.Key.toString();
  //     })
  //   },
  //     err => {

  //     })
  // }

  //=========================================getcompany list=============================//
  clearinghouseList: any = [];
  // getClearinghouseList() {
  //   this.getReport.getClearinghouse().pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
  //     this.clearinghouseList = data;
  //     this.clearinghouseList.forEach(element => {
  //       element.label = element.Value;
  //       element.value = element.Key.toString();
  //     })

  //   },
  //     err => {

  //     })
  // }
  subErr: string = "";
  generatereportSubmission() {
    let myParams = new URLSearchParams();
    this.company = (this.company == '' || this.company == null) ? '00000000-0000-0000-0000-000000000000' : this.company.toString();
    this.clearinghouse = (this.clearinghouse == '' || this.clearinghouse == null) ? '00000000-0000-0000-0000-000000000000' : this.clearinghouse.toString();
    this.groupId = (this.groupId == '' || this.groupId == null) ? '00000000-0000-0000-0000-000000000000' : this.groupId.toString();
    this.payorId = (this.payorId == '' || this.payorId == null) ? '00000000-0000-0000-0000-000000000000' : this.payorId.toString();
    this.startdate = (this.startdate == '' || this.startdate == null) ? "" : this.startdate;
    this.enddate = (this.enddate == '' || this.enddate == null) ? "" : this.enddate;
    myParams.append("CompanyId", this.company);
    myParams.append("ClearingHouseId", this.clearinghouse);
    myParams.append("GroupId", this.groupId);
    myParams.append("PayorId", this.payorId);
    myParams.append("Startdate", this.startdate);
    myParams.append("Enddate", this.enddate);
    // this.batchData.invoice837P = new Invoice837P();
    this.ngxService.start()
    this.getReport.Submissionreports(myParams).subscribe((data: any = []) => {
      this.batchData = data;
      if (data.length > 0) {

        // document.getElementById('openModal3').click();

        this.viewFiles = true;
        // document.getElementById('openModal1').click();

        this.pdflist.A4 = true,
          this.pdflist.portrait = true,
          this.pdflist.keepTogether = ".prevent-split",
          this.pdflist.scale = 0.8,
          setTimeout(() => {

            this.pdflist.saveAs("SubmissionReport" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
            //    document.getElementById("openpdfdata").click();
          }, 400);
        this.ngxService.stop()
        // this.pdflist.forcePageBreak = ".page-break",

      }
      else {
        this.ngxService.stop();
        this.saveErr = "Data not found"
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      }
      // this.clearinghouseList = data;
      // this.clearinghouseList.forEach(element => {
      //   element.label = element.Value;
      //   element.value = element.Key.toString();
      // })
    },
      (err: any) => {

        this.ngxService.stop()
        this.saveErr = err.error;
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  batchDataExceptiondata: any;
  batchDataexception: any;
  generatereportException() {
    let myParams = new URLSearchParams();
    this.company = (this.company == '' || this.company == null) ? '00000000-0000-0000-0000-000000000000' : this.company;
    this.client = (this.client == '' || this.client == null) ? '00000000-0000-0000-0000-000000000000' : this.client;
    this.groupId = (this.groupId == '' || this.groupId == null) ? '00000000-0000-0000-0000-000000000000' : this.groupId;
    this.payorId = (this.payorId == '' || this.payorId == null) ? '00000000-0000-0000-0000-000000000000' : this.payorId;
    this.employee = (this.employee == '' || this.employee == null) ? '00000000-0000-0000-0000-000000000000' : this.employee;
    // this.enddate =(this.enddate=='' || this.enddate== null )?"" : this.enddate;
    // myParams.append("typeId", this.type);
    myParams.append("CompanyId", this.company);
    myParams.append("ClientId", this.client);
    myParams.append("GroupId", this.groupId);
    myParams.append("PayorId", this.payorId);
    myParams.append("EmployeeId", this.employee);
    myParams.append("Startdate", this.exstartdate);
    myParams.append("Enddate", this.exenddate);
    // this.batchDataExceptiondata.invoice837P= new Invoice837P();
    // this.batchDataExceptiondata=[];
    // this.batchDataExceptiondata.patient_Cla/imDetail=[];
    this.ngxService.start()
    this.getReport.Exceptionreports(myParams).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {

      let sampledata = [];
      this.ngxService.stop()
      this.batchDataExceptiondata = data;
      // sampledata.forEach(element => {
      //   this.batchDataexception=element.patient_ClaimDetail;
      //   element.patient_ClaimDetail.forEach(element => {
      //   this.serviceLineDetail = element.serviceLineDetail;
      //     });

      // });

      // this.batchDataexception.forEach(element => {

      // });



      if (this.batchDataExceptiondata != null) {
        if (this.batchDataExceptiondata.length > 0) {
          this.viewFiles = true;
          // document.getElementById('openModal1').click();

          this.pdflistexcep.A4 = true,
            this.pdflistexcep.portrait = true,
            this.pdflistexcep.keepTogether = ".prevent-split",
            this.pdflistexcep.scale = 0.8,
            this.pdflistexcep.margin = { left: "0.6cm", top: "0.4cm", right: "0.6cm", bottom: "3cm" }
          setTimeout(() => {

            this.pdflistexcep.saveAs("ExceptionReport" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
            //  document.getElementById("openpdfdata").click();
          }, 400);

          // this.pdflist.forcePageBreak = ".page-break",

        }
        else {
          this.ngxService.stop()
          this.saveErr = "Data not found";
          this.toastrService.error(this.saveErr)
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);
        }
      }
      else {
        this.ngxService.stop()
        this.saveErr = "Data not found";
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      }
      // this.clearinghouseList = data;
      // this.clearinghouseList.forEach(element => {
      //   element.label = element.Value;
      //   element.value = element.Key.toString();
      // })
    },
      (err: any) => {

        this.ngxService.stop()
        if (err.message != undefined) {
          this.saveErr = err.message;
          this.toastrService.error(this.saveErr)
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);

        }
        else if (err.error != undefined) {
          this.saveErr = err.error;
          this.toastrService.error(this.saveErr)
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);
          ;
        }
        else {
          this.saveErr = err.split(':')[1];
          this.toastrService.error(this.saveErr)
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);
        }


      })
  }
  reportClientId: any;
  allBudgetDropDown: any;
  clientId: any
  getAllBudgetsForClient() {
this.selectedBudgetId = null;
    let params = new URLSearchParams();
    params.append("clientId", this.reportClientId);
    this.getReport.getAllBudgetsForClient(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.allBudgetDropDown = data;
    });
  }
  selectedBudgetId: any;
  allClientDropDown: any;
  ClientEmpList: any = [];
  reportPopup() {
    this.reportClientId = null;
    this.selectedBudgetId = null;
    document.getElementById("OpenreportFilter").click();
    // this.getAllBudgetsForClient();
  }
  // ClinetDropDown: any;
  getAllClientDropDown() {


    this.getReport.GetAllClientsDropDownbyAgency().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.allClientDropDown = data;
      this.allClientDropDown.forEach(e => {
        e.id = e.id;
      });
      this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");


      //   if(this.filter.clientId!="00000000-0000-0000-0000-000000000000")
      // {
      //   // this.budgetImportBO.clientId=this.filter.clientId;


      // }
    });

  }


  showReport() {
    let filterType: '0' | '1';

if (this.isDaily) {
  filterType = '1';
} else if (this.isWeekly) {
  filterType = '0';
} else {
  filterType = '1'; // default
}

    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Utilization Report";
    let reportId = this.ReportType == "detail" ? this.configuration.utilizationReportId : this.configuration.utilizationSummaryReportId;
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();
      let embedUrl = "";
      let embedReportId = "";
      if(this.ReportType == "detail") //Utilization detailed report
      {
      embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        reportId +
        // "&groupId=" +
        // this.configuration.PowerBIWorkSpace +
        "&rp:agencyId=" +
        this.global.globalAgencyId +
        "&rp:clientId=" +
        this.reportClientId +
        "&rp:budgetId=" +
        this.selectedBudgetId +
        "&rp:ExecTime=" +
        currentTime +   
        "&rp:filtertype_isdaily=" +
        filterType +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      }
      else{ //Utilization summary report
        embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        reportId +
        // "&groupId=" +
        // this.configuration.PowerBIWorkSpace +
        "&rp:agencyId=" +
        this.global.globalAgencyId +
        "&rp:clientId=" +
        this.reportClientId +
        "&rp:budgetId=" +
        this.selectedBudgetId +
        "&rp:ExecTime=" +
        currentTime +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      }
      embedReportId = reportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  // sampleddata()
  // {
  //   this.pdflistsample.A4 = true,
  //   this.pdflistsample.portrait = true,
  //   this.pdflistsample.keepTogether = ".prevent-split",
  //   this.pdflistsample.scale = 0.8,
  //   setTimeout(() => {

  //     this.pdflistsample.saveAs("ExceptionReport" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  //   //  document.getElementById("openpdfdata").click();
  //    },400);
  // }aa
  exception835list: any = [];
  service835: any = [];
  viewFiles835: boolean = false;
  count = 0;
  companydetails: any;
  payorDetail: any;
  paymentDetail: any;
  patientClaimDetails: any;
  sampleddata() {
    let myParams = new URLSearchParams();
    this.select835file = (this.select835file == '' || this.select835file == null) ? '0' : this.select835file;
    // this.enddate =(this.enddate=='' || this.enddate== null )?"" : this.enddate;
    // myParams.append("typeId", this.type);
    myParams.append("Id", this.select835file);
    // this.batchDataExceptiondata.invoice837P= new Invoice837P();
    // this.batchDataExceptiondata=[];
    // this.batchDataExceptiondata.patient_Cla/imDetail=[];
    this.ngxService.start()
    this.getReport.Exceptionreports835(myParams).subscribe((data: any = []) => {

      let sampledata = [];
      this.ngxService.stop()
      if (data != null) {
        this.exception835list = data;
        this.exception835list[0].transaction835s.forEach(element => {
          this.companydetails = element.companydetails
          this.payorDetail = element.payorDetail
          this.paymentDetail = element.paymentDetail
          this.patientClaimDetails = element.patient_ClaimDetails
        });

        // sampledata.forEach(element => {
        // this.batchDataexception = data.patient_ClaimDetail;

        // this.batchDataexception.forEach(element1 => {
        //   element1.count = 0;
        //   this.serviceLineDetail = element1.serviceLineDetail;
        //   this.serviceLineDetail.forEach(amt => {
        //     element1.count = element1.count + amt.billedAmt;
        //   });
        // element.count =





        // });

        // this.batchDataexception.forEach(element => {

        // });


        if (this.exception835list != '') {
          this.viewFiles835 = true;
          // document.getElementById('openModal1').click();
          this.pdflistsample.margin = { left: "0.6cm", top: "0.6cm", right: "0.6cm", bottom: "3cm" }
          // this.pdflistsample.A4 = true,
          this.pdflistsample.portrait = true,
            this.pdflistsample.keepTogether = ".prevent-split",
            this.pdflistsample.scale = 0.8,
            setTimeout(() => {

              this.pdflistsample.saveAs("ExceptionReport835" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
              //  document.getElementById("openpdfdata").click();
            }, 400);

          // this.pdflist.forcePageBreak = ".page-break",

        }
        else {
          this.ngxService.stop()
          this.saveErr = "Data not found";
          this.toastrService.error(this.saveErr)
          setTimeout(() => {
            this.toastrService.clear()
          }, 8000);
        }
      }
      else {
        this.ngxService.stop()
        this.saveErr = "Data not found";
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      }
      // this.clearinghouseList = data;
      // this.clearinghouseList.forEach(element => {
      //   element.label = element.Value;
      //   element.value = element.Key.toString();
      // })
    },
      (err: HttpErrorResponse) => {

        this.ngxService.stop()
        this.saveErr = err.message;
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  // ----------------------------------------- to get current date as default--------------------------
  dates() {
    // var d = this.date.getDate();
    // var m = this.date.getMonth() + 1; //Jan is 0
    // var yyyy = this.date.getFullYear();
    // this.startdate = m + '/' + d + '/' + yyyy;
    // this.enddate = m + '/' + d + '/' + yyyy;
    // this.gettimesheetdata();
  }



  kendopdfdownloadList() {
    this.pdflist.A4 = true,
      this.pdflist.portrait = true,
      // this.pdflist.keepTogether = ".prevent-split",
      this.pdflist.scale = 0.8,
      // this.pdflist.forcePageBreak = ".page-break",
      this.pdflist.saveAs("837Report" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());

  }


  ////////////////////////////// Download Report/////////////////////////////////////

  kendopdfdownloadListException() {
    this.pdflistexcep.A4 = true,
      this.pdflistexcep.portrait = true,
      this.pdflist.keepTogether = ".prevent-split",
      this.pdflistexcep.scale = 0.8,
      // this.pdflist.forcePageBreak = ".page-break",
      this.pdflistexcep.saveAs("ExceptionReport" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
  }


  //========================Get Group payor list=====================================================================//
  getfilter() {
    let param = new URLSearchParams();
    param.append("Code", "INACTIVECLIENTREPORTFILTER");
    this.ngxService.start()
    this.getReport.getfilterList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Reportfilter = data;
      this.Reportfilter.forEach(element => {

        element.Key = element.Key.toString();

      })
      this.ngxService.stop()



    })
  }
  //==========================get Inactive Report================================================================//
  getinactive() {
    if (isNaN(new Date(this.Report.start).getTime()) || isNaN(new Date(this.Report.end).getTime())) {
      this.saveErr = "Select a valid Start and End date";
      this.toastrService.error(this.saveErr)
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
      return;
    }
    else if (new Date(this.Report.start).getTime() > new Date(this.Report.end).getTime()) {
      this.saveErr = "End Date Should greater than Start Date"
      this.toastrService.error(this.saveErr)
      setTimeout(() => {
        this.toastrService.clear()
      }, 8000);
      return
    }
    let param = new URLSearchParams();

    param.append("filter", this.Report.filter.toString());
    param.append("start", this.Report.start);
    param.append("end", this.Report.end);
    this.ngxService.start()
    this.getReport.getReport(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ngxService.stop()
      this.InactiveClientReport = data;
      if (data.length > 0) {
        setTimeout(() => {
          this.pdflistinactive.A4 = true,
            this.pdflistinactive.portrait = true,
            // this.pdflist.keepTogether = ".prevent-split",
            this.pdflistinactive.scale = 0.8,
            // this.pdflist.forcePageBreak = ".page-break",
            this.pdflistinactive.saveAs("InactiveClientReport" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
        }, 300);

      }
      else {
        this.saveErr = "Data Not Found";
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      }
    },
      (err: HttpErrorResponse) => {
        this.saveErr = err.error;
        this.toastrService.error(this.saveErr)
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
        this.ngxService.stop()
      })
  }
  public get keepTogether(): string {
    return '';
  }


  ////////////////////////////// File uPload /////////////////////////////////////

  onFileChanged(file) {
    // this.fileToUpload.fileName=file.item(0).name;

    this.fileToUpload = file.item(0);
    //  this.selectedFileName = file.item(0).name;
    // const file = event.target.files[0];
    // $('.custom-file-input').on('change', function () {
    //   let fileName = $(this).val().split('\\').pop();
    //   $(this).siblings('.custom-file-label').addClass("selected").html(fileName);
    // });

  }
  ////////////////////////////// Save importFile/////////////////////////////////////

  onDOCFileChanged() {
    // this.fileToUpload = files.item(0);
    //   this.Importreturn.fileName=this.fileToUpload.name
    //   this.selectedFileName = this.fileToUpload.name;
    //   let body = new FormData();
    //   body.append('Filepath', this.fileToUpload);
    //   let url = "api/Import/SaveImport";
    //   this.http.post(url, body).pipe(takeUntil(this.onDestroy$)).subscribe(
    //   (data: returnimport835) => {
    //     this.Report835 = data.invoice;
    //  if( this.Report835 !=null)
    //  {
    //    document.getElementById("openModal1");
    //  }
    //     // this.dialog.open(temp);
    //     if(data.error!=null||data.error!=undefined||data.error!="")
    //     {
    //       this.toastrService.error(
    //         data.error,
    //         "File imported error",
    //       ), 8000
    //     }
    //     this.toastrService.success(
    //       "File has been imported successfully",
    //       "File imported",
    //     ), 8000


    //   },
    //   (err: HttpErrorResponse) => {
    //     this.onDOCFileChangedErr = "";
    //     this.onDOCFileChangedErr = err.error;
    //     if (this.onDOCFileChangedErr != "") {
    //       setTimeout(function () {
    //         this.onDOCFileChangedErr = "";
    //       }.bind(this), 8000);

    //     }
    //   }
    // );
  }
  get835dropdown() {
    let urldata = new URLSearchParams();
    this.getReport.get835().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.dropdown835 = data;
    })

  }
  createSpendown() {
    let urldata = new URLSearchParams();
    urldata.append("id", this.selectedFile)
    this.getReport.createspendowndlist(urldata).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.length > 0) {
        this.SpenddownList = data;

      }
      else {
        this.SpenddownList = data;
        this.toastrService.error(
          "Data Not Found",
          "Error",
        ), 8000;
      }

    },
      (err: HttpErrorResponse) => {
        this.toastrService.success(
          err.error,
          "Error",
        ), 8000;
      }
    )
  }
  kendopdfdownloadListSpendDown() {
    //let urldata=new URLSearchParams();
    //  urldata.append("Detail",this.spendwonselectData.join(', '))
    this.sendspendDown.idList = this.spendwonselectData
    this.getReport.downloadspendowndlist(this.sendspendDown).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Spenddown = data
      setTimeout(() => {

        this.pdfspendown.A4 = true,
          this.pdfspendown.portrait = true,
          this.pdfspendown.keepTogether = ".prevent-split",
          this.pdfspendown.scale = 0.8,
          this.pdfspendown.forcePageBreak = ".page-break",
          // let val= this.pdfspendown.saveAs("SpendDown" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
          this.pdfspendown.export().then((group: Group) => exportPDF(group)).then((dataUri) => {
            const base64 = dataUri.replace('data:application/pdf;base64,', '');
            const fileObject = this.dataURLtoFile(dataUri, 'test');
            var fileurl = URL.createObjectURL(fileObject);
            var d = document.getElementById("spendownreport")

            var a = window.open(fileurl, '', 'height=500, width=500');

            a.print();

          });



      }, 500);
    })
  }
  public dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  getPayer() {
    this.payerlist.GetGroupPayorList().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.revenuePayorList = data;
    }, (err: any) => {
      if (err) {
        this.toastrService.error(err, 'Error'), 8000;
      }
    });
    this.ClaimPayorList = this.revenuePayorList;

  }
  ///////////========================Get Revenue Date Filter list==================================//////////////////
  getDateLid() {
    let param = new URLSearchParams();
    param.append("Code", "REVENUEDATEFILTER");
    this.getReport.getDateLidList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.DateFilterList = data;

      if (data.length > 0) {
        this.DateFilterList.forEach(element => {

          element.Key = element.Key.toString();

        })
        this.DateFilter = this.DateFilterList[0].Key;
      }



    })
  }
  ///////////========================Get Revenue Date Filter list==================================////////////////// 

  getclaimcharge() {
    let param = new URLSearchParams();
    param.append("Code", "CLAIMCHARGEFILTER");
    this.getReport.getclaim(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.claimdatefilter = data;
      if (data.length > 0) {
        this.claimdatefilter.forEach(element => {

          element.Key = element.Key.toString();

        })
        this.claimfilter = this.claimdatefilter[0].Key;

      }



    })
  }
  // ////////////////////////
  getAgingcharge() {
    let param = new URLSearchParams();
    param.append("Code", "AGINGCHARGEFILTER");
    this.getReport.getAgingdataList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.AgingDatefilter = data;
      if (data.length > 0) {
        this.AgingDatefilter.forEach(element => {

          element.Key = element.Key.toString();

        })
        this.AgingFilter = this.AgingDatefilter[0].Key;
      }



    })
  }
  getAgingdate() {
    let param = new URLSearchParams();
    param.append("Code", "AGINGDATEFILTER");
    this.getReport.getAgingdaysList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: groupList[]) => {
      this.AgingDaysfilter = data;
      if (data.length > 0) {
        this.AgingDaysfilter.forEach(element => {

          element.Key = element.Key.toString();

        })
        this.AgingFilterchange = this.AgingDaysfilter[0].Key;
      }



    })
  }
  datefiltertype: string = "";
  changeAgingDate(vals) {

    if (vals == "0-30") {
      this.AgingStart = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 30)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
      this.AgingEnd = this.datepipe.transform(new Date(new Date().setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy")

    }
    else if (vals == "31-60") {
      this.AgingStart = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 60)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
      this.AgingEnd = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 31)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");

    }
    else if (vals == "61-90") {
      this.AgingStart = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 90)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
      this.AgingEnd = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 61)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
    }
    else if (vals == "91-120") {
      this.AgingStart = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 120)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
      this.AgingEnd = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 91)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
    }
    else if (vals == "120+") {
      // new Date(new Date(new Date().setDate(new Date().getDate() )).setHours(0, 0, 0, 0))
      this.AgingStart = this.datepipe.transform(new Date(null).toISOString().replace("Z", ""), "MM-dd-yyyy");
      this.AgingEnd = this.datepipe.transform(new Date(new Date(new Date().setDate(new Date().getDate() - 120)).setHours(0, 0, 0, 0)).toISOString().replace("Z", ""), "MM-dd-yyyy");
    }
  }
  // ////
  Token: string = "";
  // gettoken() {
  //   return new Promise((resolve, rejects) => {
  //     this.getReport.gettoken().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //       this.Token = data;
  //       resolve(data);

  //     }, (error: HttpErrorResponse) => {
  //       resolve(error.message);
  //     }
  //     )

  //   })


  // }
  closemodal() {
    document.getElementById('openReportModal').click();
    this.reportcontain = false;
  }
  gettoken() {
    return new Promise((resolve, rejects) => {
      this.getReport
        .getpowerbiToken()
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(
          (data: any) => {
            this.Token = data;
            resolve(data);
          },
          (error: HttpErrorResponse) => {
            resolve(error.message);
          }
        );
    });
  }
  dateType: string = "PreparedDate";
  // showReport() {
  //   this.reportcontain = true;
  //   this.reptitle = "Utilization Report";

  //   this.gettoken().then((token) => {
  //     document.getElementById('openModal3').click();

  //     // let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + environment.AgingReportReprotID
  //     //   + "&groupId=" + environment.PowerBIWorkSpace + "&rp:AgencyId="
  //     //   + this.global.globalAgencyId + "&rp:getreportby=" + this.dateType + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
  //     // let embedReportId = environment.AgingReportReprotID;
  //     let fromDate = this.startdate != null ? (new Date(this.startdate+ " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;
  //     let endDate = this.enddate != null ? (new Date(this.enddate + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "") : null;

  //     let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");

  //     let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + this.configuration.UtlizationReportID
  //      // + "&groupId=" + this.configuration.PowerBIWorkSpaceUtilizationReport 
  //       + "&rp:FromDate="+ fromDate+"&rp:ToDate="+endDate
  //       +"&rp:ClintId="+this.ClientId + "&rp:AgencyId="
  //       + this.global.globalHeadAgencyId + 
  //       "&rp:UserId=" + 0 +"&rp:ExecTime="+currentTime
  //       + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
  //     let embedReportId = this.configuration.UtlizationReportID;
  //     let config = {
  //       type: 'report',
  //       tokenType: pbi.models.TokenType.Aad,
  //       accessToken: token[0],
  //       embedUrl: embedUrl,
  //       id: embedReportId,
  //       settings: {},
  //       viewmode: pbi.models.ViewMode.View
  //     };

  //     let reportContainer = this.reportContainer.nativeElement;
  //     let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
  //     let report = powerbi.embed(reportContainer, config);
  //     report.off("loaded");
  //     report.on("loaded", () => {

  //     });
  //   });

  // }
  /////////////////
  ///////////========================Get Revenue Date Filter list==================================//////////////////
  getchargeLid() {

    let param = new URLSearchParams();
    param.append("Code", "REVENUECHARGEFILTER");
    this.getReport.getChargeLidList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      this.ChargeFilterList = data;
      if (data.length > 0) {
        this.ChargeFilterList.forEach(element => {
          element.Key = element.Key.toString();
        });
        this.ChargeFilter = this.ChargeFilterList[0].Key;

      }



    })
  }
  revenuetotal: any;
  getagingreportdata() {
    if (this.AgingStart != null && this.AgingStart != undefined && this.AgingStart != "" && this.AgingEnd != null && this.AgingEnd != undefined &&
      this.AgingEnd != "") {
      if (new Date(this.AgingStart).getTime() > new Date(this.AgingEnd).getTime()) {
        this.toastrService.error(
          "End Date should greater than Start Date",
          "Error",
        ), 8000;
        return;
      }
    }
    else {
      this.toastrService.error(
        "Please Select Start Date and End Date ",
        "Error",
      ), 8000;
      return;
    }
    if (this.selectedClaimPayor == "" || this.selectedClaimPayor == undefined || this.selectedClaimPayor == '') {
      this.selectedClaimPayor = "00000000-0000-0000-0000-000000000000";
    }
    let param = new URLSearchParams();
    param.append("payorId", this.selectedClaimPayor);
    param.append("fromDate", this.AgingStart);
    param.append("toDate", this.AgingEnd);
    param.append("claimdatelid", this.AgingFilter.toString())
    this.getReport.getAgingList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.AgingList = data
        setTimeout(() => {
          this.pdfagingSample.A4 = true,
            this.pdfagingSample.portrait = true,
            this.pdfagingSample.keepTogether = ".prevent-split",
            this.pdfagingSample.scale = 0.8,
            // this.pdflist.forcePageBreak = ".page-break",
            this.pdfagingSample.saveAs("ClaimversusPaid" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
        }, 400);
      }
      else {
        this.toastrService.error(
          "Data Not Found ",
          "Error",
        ), 8000;
      }
    })
  }
  payorClaimvsPaidDetails: any;

  getClaimvsPayorData() {

    if (this.ClaimStart != null && this.ClaimStart != undefined && this.ClaimStart != "" && this.ClaimEnd != null && this.ClaimEnd != undefined &&
      this.ClaimEnd != "") {
      if (new Date(this.ClaimStart).getTime() > new Date(this.ClaimEnd).getTime()) {
        this.toastrService.error(
          "End Date should greater than Start Date",
          "Error",
        ), 8000;
        return;
      }
    }
    else {
      this.toastrService.error(
        "Please Select Start Date and End Date ",
        "Error",
      ), 8000;
      return;
    }
    if (this.selectedClaimPayor == "" || this.selectedClaimPayor == undefined || this.selectedClaimPayor == '') {
      this.selectedClaimPayor = '00000000-0000-0000-0000-000000000000';
    }
    let param = new URLSearchParams();
    param.append("payorId", this.selectedClaimPayor);
    param.append("fromDate", this.ClaimStart);
    param.append("toDate", this.ClaimEnd);
    param.append("locationId", this.global.globalLocationId == null ? 0 : this.global.globalLocationId.toString());
    param.append("claimdatelid", this.claimfilter.toString())
    this.getReport.getClaimvsPaidListDetails(param).subscribe((data: any) => {
      if (data.locationClaimvsPaidDetails.length > 0) {
        this.ClaimvspaidList = data;
        this.PaidAmount = data.paidAmount;
        this.NetChargeAmount = data.netChargeAmount;
        this.Percentage = data.percentage;
        this.AddPercentage = parseFloat(this.Percentage).toFixed(2);
        this.locationClaimvsPaidDetails = data.locationClaimvsPaidDetails
        this.locationClaimvsPaidDetails.forEach(element => {
          element.percentage = parseFloat(element.percentage).toFixed(2);
          element.payorClaimvsPaidDetails.forEach(elements => {
            elements.percentage = parseFloat(elements.percentage).toFixed(2);
          });
        });
        setTimeout(() => {
          // this.ChargeFilter=this.ChargeFilterList[0].Key;
          this.pdfClaimvsPaid.A4 = true,
            this.pdfClaimvsPaid.portrait = true,
            this.pdfClaimvsPaid.keepTogether = ".prevent-split",
            this.pdfClaimvsPaid.scale = 0.8,
            // this.pdflist.forcePageBreak = ".page-break",
            this.pdfClaimvsPaid.saveAs("ClaimversusPaid" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
        }, 400);
      }
      else {
        this.toastrService.error(
          "Data Not Found ",
          "Error",
        ), 8000;
      }
    })
  }
  getFinancialData() {

    if (this.FinancialStart != null && this.FinancialStart != undefined && this.FinancialStart != "" && this.FinancialEnd != null && this.FinancialEnd != undefined &&
      this.FinancialEnd != "") {
      if (new Date(this.FinancialStart).getTime() > new Date(this.FinancialEnd).getTime()) {
        this.toastrService.error(
          "End Date should greater than Start Date",
          "Error",
        ), 8000;
        return;
      }
    }
    else {
      this.toastrService.error(
        "Please Select Start Date and End Date ",
        "Error",
      ), 8000;
      return;
    }

    let param = new URLSearchParams();
    param.append("fromDate", this.FinancialStart);
    param.append("toDate", this.FinancialEnd);
    param.append("locationId", this.global.globalLocationId == null ? 0 : this.global.globalLocationId.toString());
    this.getReport.getFinancialListDetails(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.length > 0) {
        this.FinancialList = data
        setTimeout(() => {
          // this.ChargeFilter=this.ChargeFilterList[0].Key;
          this.Financepdf.A4 = true,
            this.Financepdf.portrait = true,
            this.Financepdf.keepTogether = ".prevent-split",
            this.Financepdf.scale = 0.8,
            // this.pdflist.forcePageBreak = ".page-break",
            this.Financepdf.saveAs("Final" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
        }, 400);
      }
      else {
        this.toastrService.error(
          "Data Not Found ",
          "Error",
        ), 8000;
      }
    })
  }
  locationRevenueBO: any;
  getRevenueData() {
    if (this.revenueStart != null && this.revenueStart != undefined && this.revenueStart != "" && this.revenueEnd != null && this.revenueEnd != undefined &&
      this.revenueEnd != "") {
      if (new Date(this.revenueStart).getTime() > new Date(this.revenueEnd).getTime()) {
        this.toastrService.error(
          "End Date should greater than Start Date",
          "Error",
        ), 8000;
        return;
      }
    }
    else {
      this.toastrService.error(
        "Please Select Start Date and End Date ",
        "Error",
      ), 8000;
      return;
    }
    if (this.selectedPayor == "" || this.selectedPayor == undefined || this.selectedPayor == '') {
      this.selectedPayor = '00000000-0000-0000-0000-000000000000';
    }
    this.filterDatevalue = this.DateFilterList.filter(f => f.Key == this.DateFilter)[0].Value;
    this.filterChargevalue = this.ChargeFilterList.filter(f => f.Key == this.ChargeFilter)[0].Value;
    let param = new URLSearchParams();
    param.append("payorId", this.selectedPayor);
    param.append("locationId", this.global.globalLocationId == null ? '00000000-0000-0000-0000-000000000000' : this.global.globalLocationId.toString());
    param.append("fromDate", this.revenueStart);
    param.append("toDate", this.revenueEnd);
    param.append("filterDateLId", this.DateFilter)
    param.append("filterChargesLid", this.ChargeFilter);
    this.getReport.getRevenueList(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.locationRevenueBO.length > 0) {
        this.locationRevenueBO = data.locationRevenueBO
        if (this.filterChargevalue == "Net") {
          this.revenuetotal = this.locationRevenueBO.map(s => s.netCharges).reduce((s) => s);
        }
        else {
          this.revenuetotal = this.locationRevenueBO.map(s => s.grossCharges).reduce((s) => s);
        }
        setTimeout(() => {
          // this.ChargeFilter=this.ChargeFilterList[0].Key;
          this.pdfrevenue.A4 = true,
            this.pdfrevenue.portrait = true,
            this.pdfrevenue.keepTogether = ".prevent-split",
            this.pdfrevenue.scale = 0.8,
            // this.pdflist.forcePageBreak = ".page-break",
            this.pdfrevenue.saveAs("Revenue" + new Date().toLocaleDateString() + '-' + new Date().toLocaleTimeString());
        }, 400);
      }
      else {
        this.toastrService.error(
          "Data Not Found ",
          "Error",
        ), 8000;
      }
    })
  }


  // ==============================================================================

  // getColumnwidth() {
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);

  //   this.ColumnArray = this.arraycol[0].SpenddownReport.Columns;
  //   //       let showcol = JSON.parse(data.column)[0].SpenddownReport.ShowColumns;
  //   //     let hidecol = JSON.parse(data.column)[0].SpenddownReport.HideColumns
  //   //  //   this.grid.showColumns(showcol);
  //   //     this.grid.hideColumns(hidecol);
  //   if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
  //     this.id = this.global.globalColumn.id;
  //   }
  //   this.grid.pageSettings.pageSize = this.arraycol[0].SpenddownReport.Pagesize

  //   this.ColumnArray.forEach(element => {



  //     if (element.column == 'Client Name') {

  //       const column = this.grid.getColumnByField('client'); // get the JSON object of the column corresponding to the field name

  //       column.width = element.width;

  //       this.grid.refreshHeader();
  //       //this.grid.refreshColumns();
  //     }
  //     if (element.column == '') {

  //       const column = this.grid.getColumnByUid('checkbox'); // get the JSON object of the column corresponding to the field name

  //       column.width = element.width;

  //       this.grid.refreshHeader();
  //       //this.grid.refreshColumns();
  //     }
  //     if (element.column == 'Prepared Date') {

  //       const column1 = this.grid.getColumnByField('prepareDate'); // get the JSON object of the column corresponding to the field name

  //       column1.width = element.width;

  //       this.grid.refreshHeader();
  //     }
  //     // if (element.column == 'Invoice Date') {

  //     //   const column1 = this.grid.getColumnByField('invoiceDate'); // get the JSON object of the column corresponding to the field name

  //     //   column1.width = element.width;

  //     //   this.grid.refreshHeader();
  //     // }

  //     if (element.column == 'Claim Id') {

  //       const column1 = this.grid.getColumnByField('claimMasterId'); // get the JSON object of the column corresponding to the field name

  //       column1.width = element.width;

  //       this.grid.refreshHeader();
  //     }
  //     // if (element.column == 'Invoice Type') {

  //     //   const column1 = this.grid.getColumnByField('invoiceType'); // get the JSON object of the column corresponding to the field name

  //     //   column1.width = element.width;

  //     //   this.grid.refreshHeader();
  //     // }
  //     if (element.column == 'From Date') {

  //       const column1 = this.grid.getColumnByField('fromDate'); // get the JSON object of the column corresponding to the field name

  //       column1.width = element.width;

  //       this.grid.refreshHeader();
  //     }

  //   });
  // }
  // SaveColumnwidth() {

  //   this.arraycol[0].SpenddownReport.Columns = this.ColumnArray;
  //   this.arraycol[0].SpenddownReport.Pagesize = this.grid.pageSettings.pageSize;
  //   this.columnchange.column = JSON.stringify(this.arraycol);
  //   this.columnchange.id = this.id;

  //   this.global.globalColumn = this.columnchange;
  //   this.arraycol = JSON.parse(this.global.globalColumn.column);
  //   this.getReport.savecolumwidth(this.columnchange).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

  //     this.getColumnwidth();

  //   });
  // }



  onResize(args) {

    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    // this.ColumnArray.forEach(element => {
    //   if (element.column == column.headerText) {
    //     element.width = parseInt(column.width.toString());
    //   }

    // });
    // this.SaveColumnwidth();
  }

  GenerateReport() {
    window.open('./assets/pdf/utilization_report.pdf');
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  // showUtlizationReport(accessToken) {
  //   this.reportcontain = true;
  //   this.gettoken().then((token) => {
  //     document.getElementById('openModal3').click();


  //     let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + this.configuration.AgingReportReprotID
  //      // + "&groupId=" + this.configuration.PowerBIWorkSpace 
  //       + "&rp:AgencyId="
  //       + this.global.globalAgencyId + "&rp:getreportby=" + this.dateType +
  //       "&rp:UserId=" + this.global.userID + "&rp:LocationId=" + (this.global.globalLocationId != null ? this.global.globalLocationId : '00000000-0000-0000-0000-000000000000')
  //       + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
  //     let embedReportId = this.configuration.AgingReportReprotID;
  //     let config = {
  //       type: 'report',
  //       tokenType: pbi.models.TokenType.Aad,
  //       accessToken: token[0],
  //       embedUrl: embedUrl,
  //       id: embedReportId,
  //       settings: {},
  //       viewmode: pbi.models.ViewMode.View
  //     };
  //    console.log(config,'configutilization');

  //     let reportContainer = this.reportContainer.nativeElement;
  //     console.log(reportContainer,"report======");

  //     let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
  //     let report = powerbi.embed(reportContainer, config);

  //     report.off("loaded");
  //     report.on("loaded", () => {

  //     });
  //   });
  // }

  // allClientDropDown:any=[]
  // getAllClientDropDown() {
  //   let params = new URLSearchParams();
  //   params.append("LocationId", this.locationLid);
  //   this.timesheetservice.GetAllClientsDropDownbyAgency(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
  //     this.allClientDropDown = data;
  //     this.allClientDropDown.forEach(e => {
  //       e.id = e.id.toString();
  //     });
  //     this.ClinetDropDown = this.allClientDropDown.filter(e => e.status == "ACTIVE");

  //   });
  // }



  // ccccc// 
  editSpendDown(spendDownId) {
    let params = new URLSearchParams();
    params.append("spendDownId", spendDownId.toString());
    this.getReport
      .SpendDownFunction(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.spendDownDetails = data;
          // this.spendDownDetails.formatedPaidDate = this.datepipe.transform(
          //   this.spendDownDetails.paidDate,
          //   "MM/dd/yyyy"
          // );
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "Error");
        }
      );
  }
  spendownrowSelected(args: RowSelectEventArgs) {

    var rows: any = this.grid.getSelectedRecords();
    this.ParentSpendownId = rows.filter((t) => t.client != undefined && t.client != null && t.client != "").map((d) => d.claimMasterId);
  }


  showInactiveReport(accessToken) {

    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Inactive Client Report";
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();
      // let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + environment.AgingReportReprotID
      //   + "&groupId=" + environment.PowerBIWorkSpace + "&rp:AgencyId="
      //   + this.global.globalAgencyId + "&rp:getreportby=" + this.dateType + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      // let embedReportId = environment.AgingReportReprotID;
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.inactiveclientReportID +
        // "&groupId=" +
        // this.configuration.PowerBIWorkSpace +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:filtertype=" +
        (this.Report.filter == 'bb87358e-189f-4d6a-87ce-15c2571685e0'
          ? "NOAUTHORIZATION"
          : this.Report.filter == 'b0edcaf2-e061-4234-9492-7bc4ef875746'
            ? "NOTIMSHEET"
            : "ALL") +
        "&rp:fromdate=" +
        this.datepipe.transform(this.Report.start, "yyy-MM-dd") +
        "&rp:todate=" +
        this.datepipe.transform(this.Report.end, "yyy-MM-dd") +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.inactiveclientReportID;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }


  showrevenue(accessToken) {

    console.log(this.revenueStart, this.revenueEnd, this.selectedPayor, this.configuration.revenueReportId, this.DateFilter, "5")

    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Revenue Report";
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();



      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.revenueReportId +
        "&rp:payorid=" +
        this.selectedPayor +
        "&rp:datetype=" +
        (this.DateFilter == '9c9b4924-9973-48e2-94e3-6370a0385e24' ? "fromdate" : "prepareddate") +
        "&rp:fromdate=" +
        this.datepipe.transform(this.revenueStart, "yyyy-MM-dd") +
        "&rp:todate=" +
        this.datepipe.transform(this.revenueEnd, "yyyy-MM-dd") +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        (this.global.globalLocationId != null
          ? this.global.globalLocationId
          : '00000000-0000-0000-0000-000000000000') +
        "&rp:ExecTime=" +
        currentTime +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.revenueReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }



  showSpendDown(accessToken) {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "SpendDown Report";
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();
      // let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + environment.AgingReportReprotID
      //   + "&groupId=" + environment.PowerBIWorkSpace + "&rp:AgencyId="
      //   + this.global.globalAgencyId + "&rp:getreportby=" + this.dateType + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      // let embedReportId = environment.AgingReportReprotID;
      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.SpendDownReportId +
        // "&groupId=" +
        // this.configuration.PowerBIWorkSpace +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:AgencyId=" +
        this.global.globalAgencyId +
        "&rp:IdList=" +
        "{" +
        this.ParentSpendownId.toString() +
        "}" +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";

      let embedReportId = this.configuration.SpendDown;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }

  MarkSpendDownasNotPrinted() {
    this.getReport
      .MarkSpendDownasNotPrinted(this.ParentSpendownId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ParentSpendownId = [];
          this.childSpendownId = [];
          this.grid.dataSource = [];
          this.spendwonselectData = [];
          this.toastrService.success("Spenddown Marked As Not-Printed");
          this.spendownfilter = "False";
          if (this.spendownfilter == "False") {
            this.importBO.spendownfilter = false;
            // this.getspendowndata();
            this.ParentSpendownId = [];
          }
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }


  MarkSpendDownasPrinted() {
    this.getReport
      .MarkSpendDownasPrinted(this.ParentSpendownId)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ParentSpendownId = [];
          this.childSpendownId = [];
          this.grid.dataSource = [];
          this.spendwonselectData = [];
          this.toastrService.success("Spenddown Marked As Printed");
          this.spendownfilter = "True";
          if (this.spendownfilter == "True") {
            this.importBO.spendownfilter = true;
            // this.getspendowndata();
          }
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        },
        (err: HttpErrorResponse) => {
          this.toastrService.error(err.error, "error");
          setTimeout(() => {
            this.toastrService.clear();
          }, 8000);
        }
      );
  }

  showReportAging(accessToken) {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");

    this.reportcontain = true;
    this.reptitle = "Aging Report";
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();
      // let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + environment.AgingReportReprotID
      //   + "&groupId=" + environment.PowerBIWorkSpace + "&rp:AgencyId="
      //   + this.global.globalAgencyId + "&rp:getreportby=" + this.dateType + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      // let embedReportId = environment.AgingReportReprotID;
      let embedUrl = "";
      let embedReportId = "";
      if (this.locBreak == "Yes") {
        embedUrl =
          "https://app.powerbi.com/rdlEmbed?reportId=" +
          this.configuration.AgingReportReprotID +
          // "&groupId=" +
          // this.configuration.PowerBIWorkSpace +
          "&rp:AgencyId=" +
          this.global.globalAgencyId +
          "&rp:getreportby=" +
          this.dateType +
          "&rp:ExecTime=" +
          currentTime +
          "&rp:UserId=" +
          this.global.userID +
          "&rp:LocationId=" +
          (this.global.globalLocationId != null
            ? this.global.globalLocationId
            : '00000000-0000-0000-0000-000000000000') +
          "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
        embedReportId = this.configuration.AgingReportReprotID;
      }
      if (this.locBreak == "No") {
        embedUrl =
          "https://app.powerbi.com/rdlEmbed?reportId=" +
          this.configuration.AgingwithoutLocBreak +
          // "&groupId=" +
          // this.configuration.PowerBIWorkSpace +
          "&rp:AgencyId=" +
          this.global.globalAgencyId +
          "&rp:getreportby=" +
          this.dateType +
          "&rp:ExecTime=" +
          currentTime +
          "&rp:UserId=" +
          this.global.userID +
          "&rp:LocationId=" +
          (this.global.globalLocationId != null
            ? this.global.globalLocationId
            : '00000000-0000-0000-0000-000000000000') +
          "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
        embedReportId = this.configuration.AgingwithoutLocBreak;
      }
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }

  showCheckEFT(accessToken) {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Cheques / EFT Details";
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();
      // let embedUrl = "https://app.powerbi.com/rdlEmbed?reportId=" + environment.AgingReportReprotID
      //   + "&groupId=" + environment.PowerBIWorkSpace + "&rp:AgencyId="
      //   + this.global.globalAgencyId + "&rp:getreportby=" + this.dateType + "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      // let embedReportId = environment.AgingReportReprotID;

      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.CheckEFTReportId +
        // "&groupId=" +
        // this.configuration.PowerBIWorkSpace +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:ExecTime=" +
        currentTime +
        "&rp:fromdate=" +
        this.datepipe.transform(this.FinancialStart, "yyyy-MM-dd") +
        "&rp:todate=" +
        this.datepipe.transform(this.FinancialEnd, "yyyy-MM-dd") +
        "&rp:userid=" +
        this.global.userID +
        "&rp:locationid=" +
        (this.global.globalLocationId != null
          ? this.global.globalLocationId
          : '00000000-0000-0000-0000-000000000000') +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.CheckEFTReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }
  showClaimVsPaid(accessToken) {
    let currentTime = this.datepipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.reportcontain = true;
    this.reptitle = "Claim Vs Paid Report";
    this.gettoken().then((token) => {
      document.getElementById("openModal3").click();

      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.ClaimVsPaidReportId +
        "&rp:payorid=" +
        this.selectedClaimPayor +
        "&rp:datetype=" +
        (this.DateFilterclaim == '9c9b4924-9973-48e2-94e3-6370a0385e24' ? "fromdate" : "prepareddate") +
        "&rp:fromdate=" +
        this.datepipe.transform(this.ClaimStart, "yyyy-MM-dd") +
        "&rp:todate=" +
        this.datepipe.transform(this.ClaimEnd, "yyyy-MM-dd") +
        "&rp:agencyid=" +
        this.global.globalAgencyId +
        "&rp:locationid=" +
        (this.global.globalLocationId != null
          ? this.global.globalLocationId
          : '00000000-0000-0000-0000-000000000000') +
        "&rp:ExecTime=" +
        currentTime +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";
      let embedReportId = this.configuration.ClaimVsPaidReportId;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };

      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }

  closeClaimmodal() {
    document.getElementById("openModal3").click()
    this.reportcontain = false;
    this.reptitle = ''
  }
}
